import React from "react";
import LegalPageLayout, { LEGAL_OWNER } from "./LegalPageLayout";

export default function LegalNoticePage() {
  return (
    <LegalPageLayout
      title="Aviso legal"
      subtitle="Información general del titular y condiciones de acceso al sitio web."
      updatedAt="18 de febrero de 2026"
    >
      <section className="panel">
        <h2 className="panel-title">Identificación del prestador (LSSI art. 10)</h2>
        <p>
          Titular del sitio: {LEGAL_OWNER.legalName} ({LEGAL_OWNER.legalForm}), NIF {LEGAL_OWNER.nif}, con domicilio a efectos
          de contacto en {LEGAL_OWNER.address}. Email de contacto legal: {LEGAL_OWNER.email}.
        </p>
        <p>
          Nombre comercial del servicio: {LEGAL_OWNER.brand}. Dominio principal: {LEGAL_OWNER.domain}.
        </p>
      </section>

      <section className="panel">
        <h2 className="panel-title">Objeto</h2>
        <p>
          Este sitio web informa sobre el servicio {LEGAL_OWNER.brand}, una aplicación web para la gestión financiera personal
          mediante importación y análisis de movimientos bancarios.
        </p>
      </section>

      <section className="panel">
        <h2 className="panel-title">Condiciones de uso</h2>
        <p>
          El acceso al sitio implica la aceptación de este aviso legal, la política de privacidad, la política de cookies y las
          condiciones de uso. El usuario se compromete a realizar un uso lícito, diligente y conforme a la normativa aplicable.
        </p>
      </section>

      <section className="panel">
        <h2 className="panel-title">Comunicaciones comerciales y actividad</h2>
        <p>
          La actividad principal del sitio es la prestación de un servicio digital de organización financiera personal. No se
          presta asesoramiento financiero, fiscal o de inversión personalizado ni se intermedian operaciones bancarias.
        </p>
      </section>

      <section className="panel">
        <h2 className="panel-title">Propiedad intelectual e industrial</h2>
        <p>
          Los contenidos, diseño, marca, logotipos, código y elementos gráficos del sitio son titularidad del responsable o de sus
          licenciantes. Queda prohibida su reproducción, distribución o transformación sin autorización expresa.
        </p>
      </section>

      <section className="panel">
        <h2 className="panel-title">Responsabilidad</h2>
        <p>
          El titular no garantiza la disponibilidad continua del servicio ni la ausencia de errores técnicos. En ningún caso el sitio
          constituye asesoramiento financiero, fiscal o de inversión; el usuario debe tomar decisiones bajo su propia responsabilidad.
        </p>
      </section>

      <section className="panel">
        <h2 className="panel-title">Enlaces externos</h2>
        <p>
          Este sitio puede incluir enlaces a servicios de terceros (por ejemplo, pasarela de pago). El titular no es responsable de
          los contenidos, políticas o prácticas de dichos sitios externos.
        </p>
      </section>

      <section className="panel">
        <h2 className="panel-title">Seguridad</h2>
        <p>
          Se aplican medidas técnicas y organizativas razonables para proteger la información y prevenir accesos no autorizados,
          alteraciones o pérdida de datos.
        </p>
      </section>

      <section className="panel">
        <h2 className="panel-title">Jurisdicción y resolución de conflictos</h2>
        <p>
          La relación con las personas usuarias se rige por la normativa española. Cuando la persona usuaria tenga condición de
          consumidora, serán competentes los juzgados y tribunales que establezca la normativa de consumo vigente.
        </p>
      </section>

      <section className="panel">
        <h2 className="panel-title">Normativa aplicable</h2>
        <p>
          Este aviso se interpreta conforme a la normativa española, incluyendo la Ley 34/2002 de Servicios de la Sociedad de la
          Información (LSSI-CE), el Reglamento (UE) 2016/679 (RGPD), la Ley Orgánica 3/2018 (LOPDGDD) y la normativa de protección
          de personas consumidoras aplicable a contratos a distancia de servicios digitales.
        </p>
      </section>
    </LegalPageLayout>
  );
}
